import React from 'react';

import { Component } from 'react';

import { Divider } from '@material-ui/core';
import { connect } from 'react-redux';
import {
  addClinic,
  getClinics,
  getPaitentsWithNoActive,
  getPatients,
  navigateTo,
  setError,
  setPatientsList,
  setSelectedClinic,
  setUsersClinic,
} from '../../../redux/actions';

import ClinicList from '../../clinic/ClinicList';
import ClinicModal from '../../clinic/ClinicModal';
import { Loading } from '../../common';
import Header from '../../common/Header';
import AdminLayout from './AdminLayout';

import { Items, Storage } from '../../../utils/StorageHelper';
import Alerts from '../../common/Alerts';
import BackToPage from '../../common/back-to-page';

class AdminPanelclinic extends Component {
  state = {
    showModal: false,
  };

  componentDidMount() {
    Storage.remove(Items.clinicId);
    this.props.setSelectedClinic(null);
    this.props.setPatientsList(null);
    this.props.setUsersClinic(null);
    this.props.getClinics();
    const { selectedClinic } = this.props;
    console.log({ selectedClinic });
  }
  openModal = () => {
    this.props.setError();
    this.setState({ ...this.state, showModal: true });
  };
  closeModal = () => {
    this.setState({ ...this.state, showModal: false });
  };

  render() {
    console.log(JSON.stringify(this.props.user.error));
    return this.props.clinic.clinicList ? (
      <div>
        <AdminLayout {...this.props}>
          <Alerts />
          <BackToPage />
          <ClinicModal closeModal={this.closeModal} showModal={this.state.showModal} handleClick={this.props.addClinic} title="Add Clinic" />
          <div style={styles.container1}>
            <Header />
          </div>
          <h1>clinics</h1>
          <button style={styles.button} onClick={() => this.openModal()}>
            add clinic
          </button>
          <Divider />

          { <ClinicList status={this.state.status} />}
        </AdminLayout>
      </div>
    ) : (
      <Loading />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    login: state.login,
    user: state.user,
    clinic: state.clinic,
    loginUser: state.login.loginUser,
    patientsList: state.clinic.patientsList,
    selectedClinic: state.clinic.selectedClinic,
  };
};

const styles = {
  container1: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  error: {
    fontWeight: 'bold',
    color: '#f7183a',
  },
  button: {
    cursor: 'pointer',
    backgroundColor: '#4CAF50',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
};

const mapDispatchToProps = {
  navigateTo,
  getPatients,
  getClinics,
  addClinic,
  setError,
  getPaitentsWithNoActive,
  setSelectedClinic,
  setUsersClinic,
  setPatientsList,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminPanelclinic); //{JSON.stringify(this.props.user)}
